// Formatting helpers shared across pages.

export function formatMoney(value: number, currency = 'USD'): string {
  if (value == null || Number.isNaN(value)) return '—'
  const abs = Math.abs(value)
  const fmt = (n: number, suffix: string) =>
    `${(value / n).toLocaleString(undefined, { maximumFractionDigits: 1 })}${suffix}`
  let short: string
  if (abs >= 1e9) short = fmt(1e9, 'B')
  else if (abs >= 1e6) short = fmt(1e6, 'M')
  else if (abs >= 1e3) short = fmt(1e3, 'K')
  else short = value.toLocaleString(undefined, { maximumFractionDigits: 0 })
  const symbol = currency === 'USD' ? '$' : `${currency} `
  return `${symbol}${short}`
}

export function formatDate(iso?: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}

// daysSince returns whole days between now and an ISO timestamp (null when absent/invalid).
export function daysSince(iso?: string | null): number | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return Math.floor((Date.now() - d.getTime()) / 86_400_000)
}

export function formatPct(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return '—'
  return `${value.toFixed(1)}%`
}

export function formatNumber(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return '—'
  return value.toLocaleString()
}
